// extracted by mini-css-extract-plugin
export default {"gauge":"UtilizationGauge_gauge__1Sr+K","arcTrack":"UtilizationGauge_arcTrack__AXoqh","arcFill":"UtilizationGauge_arcFill__7JaQ2","valueLabel":"UtilizationGauge_valueLabel__TymFN"};